<template>
  <div class="serive">
    <div class="serivehtml">
      <div class="headtxt">
        <div class="head">
          <ResTxt
            id="e093ae6de4624"
            style="
              font-size: 18px;
              color: #275479;
              font-weight: bold;
              line-height: 30px;
            "
          />
          <br>
          <ResTxt 
            id="44610a0863292"
            style="
              font-size: 15px;
              color: #000000;
              line-height: 26px;
              letter-spacing: 1px;
              z-index: 11;
            "
          />
          <!-- <p
            style="
              font-size: 18px;
              color: #275479;
              font-weight: bold;
              line-height: 30px;
            "
          >
            服务渠道
          </p>

          <p
            style="
              font-size: 15px;
              color: #000000;
              line-height: 26px;
              letter-spacing: 1px;
            "
          >
            咨询软件使用方法，反馈软件的问题或对软件功能有什么建议，请按照以下渠道寻求帮助
          </p> -->
        </div>
      </div>
      <div class="bodycss">
        <div class="title">
          <p class="tiao1"></p>
          <!-- <p class="tiao2">论坛提问</p> -->
          <ResTxt class="tiao2" id="59ea907e8128d" />
          <p class="tiao3">渠道一</p>
        </div>
        <ul class="text" style="margin-right: 75px">
          <li>
            <div class="square"></div>
            <!-- 论坛是文华服务用户的主流渠道。 -->
            <ResTxt style="width: auto;" id="91c995e2b7d41" />
          </li>
          <li>
            <div class="square"></div>
            <!-- 论坛配备一支专业金融工程师团队，每日14个小时的在线值守，解答投资者提出的各种软件使用问题。 -->
            <ResTxt style="width: auto;" id="9fe9c32f8e397" />
          </li>
          <li style="text-indent: -1.5em; margin-left: 1.5em">
            <div class="square"></div>
            <!-- wh6/随身行/wh10相关问题30分钟内回复、wh7/wh8/wh9相关问题10分钟内回复，每天我们处理上千个用户的帖子，上一个年度我们解答了122040个用户的问题。 -->
            <ResTxt style="width: auto;text-indent: 0;vertical-align: top;" id="03815bc59abb3" />
            <!-- 保证15分钟内的回复速度，每天我们处理上千个用户的帖子，上一个年度我们解答了122040个用户的问题。 -->
          </li>
          <li>
            <div class="square"></div>
            <!-- 金融工程师团队成员，由具有金融类本科学历、持有期货从业资格证的专业人员组成。 -->
            <ResTxt style="width: auto;" id="ae1ad8fa4e611" />
          </li>
        </ul>
        <ResTxt
          id="d4abfad5c4b60"
          style="
            margin-left: 75px;
            color: #214078;
            font-size: 15px;
            margin-top: 50px;
            margin-bottom: 60px;
            letter-spacing: 1px;
          "
        />
        <!-- <p
          style="
            margin-left: 75px;
            color: #214078;
            font-size: 15px;
            margin-top: 50px;
            margin-bottom: 60px;
            letter-spacing: 1px;
          "
        >
          论坛入口：软件界面的右上角菜单，[帮助]－>论坛提问
        </p> -->
        <div class="title">
          <p class="tiao1"></p>
          <!-- <p class="tiao2">
            <span style="margin-left: 24px">Call_Center</span>
          </p> -->
          <ResTxt class="tiao2" style="text-indent: 24px" id="4696d591bf76a" />
          <p class="tiao3">渠道二</p>
        </div>
        <ul class="text">
          <li>
            <div class="square"></div>
            <ResTxt style="width: auto;" id="75b555399fc2a" />
            <!-- 呼叫中心配备一支金融工程师团队，接听用户电话，解决用户问题。 -->
          </li>
          <li>
            <div class="square"></div>
            <ResTxt style="width: auto;" id="aa4c3c9e7c6e9" />
            <!-- 金融工程师团队成员，由具有金融类本科学历、持有期货从业资格证的专业人员组成。 -->
          </li>
        </ul>
        <ResTxt
          id="f81a997fa7c0b"
          style="
            margin-left: 75px;
            color: #8d6a33;
            font-size: 19px;
            margin-top: 35px;
            font-weight: bold;
          "
        />
        <br>
        <ResTxt
          id="ef12eb4c1288e"
          style="
            margin-left: 75px;
            color: #b6b6b6;
            font-size: 12px;
            letter-spacing: 1px;
          "
        />
        <!-- <p
          style="
            margin-left: 75px;
            color: #8d6a33;
            font-size: 19px;
            margin-top: 35px;
            font-weight: bold;
          "
        >
          400-811-3366
        </p>
        <p
          style="
            margin-left: 75px;
            color: #b6b6b6;
            font-size: 12px;
            letter-spacing: 1px;
          "
        >
          （工作日8:00～22:00，五一、十一、春节初三至初六16:30～20:30）
        </p> -->
      </div>
    </div>
    <wh7footer></wh7footer>
  </div>
</template>

<script>
import wh7footer from "./components/wh7/wh7footer.vue";
import ResTxt from '@/ResData/ResTxt'
export default {
  components: {
    wh7footer,
    ResTxt
  },
};
</script>

<style scoped>
.serivehtml {
  background: url("../../assets/images/fwqd-bg.92aad835.jpg") no-repeat center;
  background-size: auto 100%;
  height: 839px;
  min-width: 1400px;
  width: 100%;
}
.headtxt {
  position: relative;
  height: 160px;
  width: 1000px;
  margin: 0 auto;
}
.head {
  position: absolute;
  top: 100px;
}
.bodycss {
  bottom: 0;
  width: 1005px;
  margin: 0 auto;
  height: 635px;
  background: white;
}
.title {
  position: relative;

  height: 45px;
}
.tiao1 {
  position: absolute;
  background: url("../../assets/images/tiao1.jpg") no-repeat;
  width: 1005px;
  height: 35px;
  letter-spacing: 1px;
}
.tiao2 {
  position: absolute;
  background: url("../../assets/images/tiao2.jpg");
  width: 230px;
  height: 40px;
  text-align: center;
  color: white;
  font-size: 17px;
  line-height: 40px;
  letter-spacing: 1px;
}
.tiao3 {
  position: absolute;
  background: url("../../assets/images/tiao3.jpg");
  width: 60px;
  height: 40px;
  top: 5px;
  text-align: center;
  font-size: 14px;
  line-height: 40px;
  font-weight: bold;
  letter-spacing: 1px;
  z-index: 10;
}
.square {
  height: 8px;
  width: 8px;
  background: #1f4075;
  display: inline-block;
  margin-right: 12px;
  letter-spacing: 1px;
}
.text {
  margin-top: 15px;
  margin-left: 75px;
  line-height: 37px;
  color: #636363;
  font-size: 15px;
}
</style>